var map = {
	"./cert-finance-cpttm-sc.jpg": 271,
	"./cert-fsi-cpttm-sc.jpg": 273,
	"./cert-general-staff-a-cpttm-sc.jpg": 275,
	"./cert-general-staff-cpttm-sc.jpg": 277,
	"./cert-general2024-cpttm-sc.jpg": 207,
	"./cert-senior-manager-cpttm-sc.jpg": 283,
	"./cert-student-cpttm-sc.jpg": 286
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2667;